var reactDirtyRoute = require('../mixins/react-dirty-route')

module.exports = Em.Route.extend(reactDirtyRoute, {})
